module.exports = __webpack_public_path__ + "static/media/Mask-Group-16.0e4044cc.svg";